<template>
  <div>
    <h1>Tooltip</h1>
    <table style="margin: 3em; padding: 3em" border>
      <tr><td><div class="test-tooltip-target">test1</div></td></tr>
      <tr><td><div class="test-tooltip-target">test2</div></td></tr>
      <tr><td><div class="test-tooltip-target">test3</div></td></tr>
      <tr><td><div class="test-tooltip-target">test4</div></td></tr>
    </table>

    test1: {{test1}} <br />
    input: <el-input v-model="test1" />

    <!-- <el-popover
     placement="top-start"
     title="Title"
     width="200"
     trigger="hover"
     content="this is content, this is content, this is content">
     <el-button slot="reference">Hover to activate</el-button>
   </el-popover> -->

   <!-- <my-test-popover v-if="element" :reference="element" /> -->
   <div id="calendar-popover-list">

   </div>
  </div>
</template>

<script>
// import PopperJS from 'popper.js'
// import Tooltip from 'tooltip.js'
import Vue from 'vue'

const CALENDAR_POPOVER_DOM_NODE_ID = 'calendar-popover-container';

function reactiveWrapComponent( component, data ) {
  return new Vue({
    data () {
      return data
    },
    render (h) {
      return h(component, { props: this.$data })
    },
  })
}

const elementPopoverContent = {
  props: {
    reference: {},
    parentData: {
      default: () => ({
        test1: -1
      })
    }
  },
  template: `
  <div class="popover1">
    INFO: {{parentData}}
    <el-popover
     placement="left-start"
     title="Title"
     width="600"
     trigger="hover"
     :popper-options="{
       container: 'calendar-popover-container'
     }"
     :reference="reference"
     ref="popover">
     Info: {{parentData.test1}}
   </el-popover>
   </div>
  `,
  beforeDestroy() {
    const popoverComp = this.$refs.popover;
    // console.log("this.$refs.popover", this.$refs.popover);
    // console.log("popoverComp.$refs.popper", popoverComp.$refs.popper);
    // console.log("popoverComp.popper", popoverComp.popper);
    // console.log("popoverComp.popperJS", popoverComp.popperJS);
    popoverComp.doDestroy();
  }
};

export default {
  data: () => ({
    test1: 1,
    // element: null,
  }),
  created: function () {
    this._popoverList = [];
  },
  mounted: function() {
    // console.log("TOOLTIP");
    const referencedElements = document.getElementsByClassName("test-tooltip-target");
    // console.log("REFS", referencedElements);
    // this.element = referencedElement;

    // var elementPopoverContentCtor = Vue.extend(elementPopoverContent)
    // console.log("class", elementPopoverContentCtor);

    let containerNode = document.getElementById(CALENDAR_POPOVER_DOM_NODE_ID);
    if ( !containerNode ) {
      containerNode = document.createElement('div')
      containerNode.setAttribute("id", CALENDAR_POPOVER_DOM_NODE_ID);
      document.body.appendChild( containerNode );
    }
    // clear node?
    // console.log("containerNode", containerNode);

    for (let node of referencedElements) {
      // var instance = new elementPopoverContentCtor({
      //   propsData: {
      //     reference: node,
      //     info: this.test1 // node.innerHTML
      //   }
      // });
      let reactiveData = {
        reference: node,
        parentData: this.$data
        // data: { test1: this.$data.test1 } --> geht nicht
      }
      var instance = reactiveWrapComponent( elementPopoverContent, reactiveData )
      // console.log("node - instance2", node, instance);

      /* Create vue instance and save reference in _popoverList */
      // instance.$mount("#calendar-popover-list")
      // instance.$mount()
      instance.$parent = this;
      instance.$mount()
      this.$children.push( instance );
      this._popoverList.push( instance );

      /* append rendered DOM node to containerNode */
      containerNode.appendChild( instance.$el );
      /* not necessary because we use reference */
    }

    // console.log("this._popoverList", this._popoverList);
  },
  beforeDestroy: function() {
    console.log("*** beforeDestroy - not called on HMR ***");

    this._popoverList.forEach(vm => {
      vm.$destroy();
    });

    var containerNode = document.getElementById(CALENDAR_POPOVER_DOM_NODE_ID);
    while (containerNode.firstChild) {
      containerNode.removeChild(containerNode.firstChild);
    }
  },
  computed: {
  },
  methods: {
  },
  components: {
    // elementPopoverContent
  }
}

</script>

<style>
.test-tooltip-target {
  cursor: pointer;
}
</style>
